module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/inactive/golf-e5e5bf71c8bd3f8be26d49cba558825f.svg";